import { GenericInput } from '@app/form';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';
import React, { useCallback } from 'react';
import { Criterion, NewQuota, Quota } from '@app/api';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    width: theme.marginBase * 10,
  },
  inputGroup: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.borderRadius.std,
    border: `1px solid ${theme.colors.grayBorder}`,
    overflow: 'hidden',
    backgroundColor: theme.colors.white,
    width: theme.marginBase * 10,
    height: '100%',
  },
  inputGroupError: {
    border: `1px solid ${theme.colors.redAccessible}`,
  },
  input: {
    textAlign: 'right',
    border: 'none',
    outline: 'none',
    padding: [[theme.marginBase / 2, theme.marginBase]],
    flex: 1,
    minWidth: 0,
    '&::-webkit-outer-spin-button': {
      display: 'none',
    },
    '&::-webkit-inner-spin-button': {
      display: 'none',
    },
    '-moz-appearance': 'textfield',
  },
  icon: {
    color: theme.colors.inkTertiary,
    whiteSpace: 'nowrap',
    borderLeft: `1px solid ${theme.colors.grayBorder}`,
    backgroundColor: theme.colors.grayBackground,
    padding: [[theme.marginBase / 2, theme.marginBase]],
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
}));

interface Props {
  choice: string;
  criterion?: Criterion;
  quota: Quota | NewQuota | undefined;
  quotas: Quota[];
  disabled?: boolean;
  onChange?: (criterion: Criterion) => any;
}

export const InputContent = ({
  choice,
  criterion,
  quota,
  quotas,
  disabled,
  onChange,
}: Props) => {
  const classes = useStyles();

  const _onChange = useCallback(
    (newValue: number) => {
      const index = quotas.findIndex((q) => q.item === choice);
      quotas[index] = { ...quotas[index], value: newValue };

      criterion && onChange && onChange({ ...criterion, quotas: quotas });
    },
    [choice, criterion, onChange, quotas],
  );

  return (
    <div className={classnames(classes.inputGroup)}>
      <input
        type="number"
        placeholder="-"
        className={classes.input}
        disabled={disabled}
        value={quota?.value ?? quota?.max ?? ''}
        onChange={(e) => {
          const val = e.target.value;
          _onChange(val ? parseInt(val, 10) : 0);
        }}
      />
      <div className={classes.icon}>
        <i className={classnames(['ri-user-3-line'])} />
      </div>
    </div>
  );
};

export const FieldQuota = ({
  choice,
  criterion,
  quota,
  quotas,
  disabled,
  onChange,
}: Props) => {
  const classes = useStyles();
  return (
    <GenericInput
      fullHeight
      noMargin
      choice={choice}
      criterion={criterion}
      quota={quota}
      quotas={quotas}
      component={InputContent}
      disabled={disabled}
      containerClass={classes.container}
      onChange={onChange}
    />
  );
};
